import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`My thanks to /r/churning in general`}</strong>{` for being a great community and for all the info needed to keep this chart up-to-date, `}<strong parentName="p">{`to the mods`}</strong>{`, and `}<strong parentName="p">{`to these users in particular`}</strong>{` for comments that improved the flowchart or notes: /u/aoechamp, /u/the_fit_hit_the_shan, /u/pizzywoah, /u/PeteyNice, /u/Renaud04, /u/BrainSturgeon, /u/idontwantaname123, /u/mk712, /u/blinyellow, /u/milespoints, /u/GamingBuck, /u/bullfrog23414, /u/Soulsandwich, /u/sidek021, /u/preston_f, /u/nobody65535, /u/AtSomePointItMatters, /u/Blaize122, /u/pawfee, /u/dragonflysexparade, /u/duffcalifornia, /u/Lieroo, /u/DanmakuLife, /u/nmperson, /u/mikep4, /u/Foxua, /u/Heartlanta, /u/Chong786, /u/akdb8r, /u/caedin8, /u/daneo345, /u/Better_than_Trajan, /u/hellomedworld, /u/yt-nthr-rddtr, /u/kid_iculous, /u/blueeyes_austin, /u/OJtheJEWSMAN, /u/Schaudenfreuding, /u/m16p, /u/ktfzh64338, /u/Cyclone`}{`_`}{`_`}{`Power, /u/emteereddit, /u/grunthos503, /u/JerseyKeebs, /u/sutsusame, /u/Blootie1994, /u/b2flyer23, /u/cd_root, /u/tom0963, /u/reelbgpunk, /u/BalthazarOfNavarre, /u/mikep4, /u/cubervic, /u/shinebock, /u/AnHeroicHippo, /u/albatross07, /u/Econ0mist, /u/Churning_Fun`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      